import translations from 'client/internationalization/translation-map.json';
import { QueryTemplateAuditAction } from 'common/enums/query-enums';
import { IQueryTemplateAuditEntry, TQueryTemplateSnapshot } from 'common/interfaces/query';
import { IUser } from 'common/interfaces/customer-interfaces';

export const QUERY_AUDIT_ACTION_LABEL_MAP: Record<QueryTemplateAuditAction, string> = {
  [QueryTemplateAuditAction.Create]: translations.created,
  [QueryTemplateAuditAction.Update]: translations.query_historyUpdated,
  [QueryTemplateAuditAction.Promote]: translations.query_historyPromoted,
  [QueryTemplateAuditAction.Delete]: translations.query_historyDeleted,
};

export const QUERY_AUDIT_FIELD_LABEL_MAP: Record<keyof TQueryTemplateSnapshot, string> = {
  queryName: translations.query_queryName,
  conditionGroups: translations.query_historyConditions,
  groupsOperator: translations.query_historyGroupsOperator,
  groupBy: translations.query_groupBy,
  dataType: translations.query_historyDataType,
  archiveid: translations.archive,
  ownerType: translations.query_access,
  owner: translations.query_historyOwner,
  companyid: translations.query_ownerTypeCompany,
};

/**
 * Finds the display name of the user who made a change.
 * @param users - The company's users
 * @param subjectId - The subjectid stored in the audit entry
 * @returns First and last name, or the subjectid when the user is unknown
 */
export const getAuditUserName = (users: IUser[] | undefined, subjectId: string): string => {
  const user = users?.find(companyUser => companyUser.subjectId === subjectId);
  return user ? `${user.firstName} ${user.lastName}`.trim() : subjectId;
};

/**
 * Lists the template fields an entry changed, by comparing the template before and after it.
 * @param entry - The audit entry
 * @returns The changed fields, empty for a create or a delete
 */
export const getChangedFields = (entry: IQueryTemplateAuditEntry): (keyof TQueryTemplateSnapshot)[] => {
  const { before, after } = entry.information;
  if (!before || !after) {
    return [];
  }
  return (Object.keys(QUERY_AUDIT_FIELD_LABEL_MAP) as (keyof TQueryTemplateSnapshot)[])
    .filter(field => JSON.stringify(before[field] ?? null) !== JSON.stringify(after[field] ?? null));
};
